import { render, staticRenderFns } from "./addTransferMajor.vue?vue&type=template&id=25499f20&"
import script from "./addTransferMajor.vue?vue&type=script&lang=js&"
export * from "./addTransferMajor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports